import { createSlice } from '@reduxjs/toolkit';
import { LeadsManagementState } from './types';

export const initialState: LeadsManagementState = {
  token: '',
  loading: false,
  error: ''
};

const localeSlice = createSlice({
  name: 'LeadsManagement',
  initialState,
  reducers: {
    fetchToken: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchTokenSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
    fetchTokenFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const { fetchToken, fetchTokenSuccess, fetchTokenFailure, resetState } = localeSlice.actions;

export default localeSlice.reducer;
